import { Box, Button, Portal, Typography, Container } from "@mui/material";
import React, {
  lazy,
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Logo from "../../assets/icons/enomo_logo.svg";
import "./header.css";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../store/hooks/store.hooks";

import { useNavigate } from "react-router-dom";
import { HeaderSelector } from "./header.selector";
import {
  setAuthorizationModal,
  setRegistrationModal,
} from "../../store/models/auth/auth.slice";
import { AccountSection } from "../AccountSection/account.section";
import { fetchMyActivatedBonuses } from "../../store/models/bonuses/bonuses.thunk";

export const Header = () => {
  const { t } = useTranslation();
  // const [mounted, setMounted] = useState(false);
  const [active, setActive] = useState(false);
  const dispatch = useAppDispatch();

  // const handleVerifyAuthUser = useCallback(() => {
  //   if (!mounted) {
  //     dispatch(verifyAuthUser());
  //     setMounted(true);
  //   }
  // }, [dispatch, mounted]);

  // useEffect(() => {
  //   handleVerifyAuthUser();
  // }, [handleVerifyAuthUser]);

  const navigate = useNavigate();
  const { auth, userBalance, active_bonus, wallet } =
    useAppSelector(HeaderSelector);
  useEffect(() => {
    if (auth) {
      dispatch(fetchMyActivatedBonuses({}));
    }
  }, [auth]);

  return (
    <Box className="header">
      <Container
        className="container"
        maxWidth={false}
        disableGutters
        sx={{ display: "flex" }}
      >
        <Box
          className="header__logo"
          onClick={() => {
            navigate("/");
          }}
        >
          <img src={Logo} alt="Enomo" />
        </Box>
        <Box className="header__buttons">
          <Box className="header__categories">
            <button
              className="header__categories-button"
              onClick={() => {
                navigate("/lobby/crash");
              }}
            >
              {t("buttons.fast_games")}
            </button>
            <button
              className="header__categories-button"
              onClick={() => {
                navigate("/bonuses");
              }}
            >
              {t("buttons.bonuses")}
            </button>
            <button
              className="header__categories-button"
              onClick={() => {
                navigate("/lobby/slots");
              }}
            >
              {t("buttons.slots")}
            </button>
            <button
              className="header__categories-button"
              onClick={() => {
                navigate("/lobby/live");
              }}
            >
              {t("buttons.live")}
            </button>
          </Box>
          <Box className="header__buttons-container">
            {auth ? (
              <>
                <button
                  className={
                    active_bonus
                      ? "header__button balance-button with-bonus"
                      : "header__button balance-button"
                  }
                  onClick={() => {
                    setActive(true);
                  }}
                >{`${userBalance}`}</button>
                <button
                  className="header__button deposit-button pulse-button"
                  onClick={() => {
                    navigate("/profile/payments");
                  }}
                >
                  {t("buttons.shorttopup")}
                </button>
                <AccountSection
                  active={active}
                  setActive={setActive}
                  activeBonus={active_bonus}
                  wallet={wallet}
                />
              </>
            ) : (
              <>
                <button
                  className="header__button signin-button"
                  onClick={() => {
                    dispatch(setAuthorizationModal(true));
                  }}
                >
                  {t("authorization.title")}
                </button>
                <button
                  className="header__button signup-button pulse-button"
                  onClick={() => {
                    dispatch(setRegistrationModal(true));
                  }}
                >
                  {t("registration.title")}
                </button>
              </>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
